import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuComponent } from "../../components/menu/menu.component";
import { ApiService, CommonFunctionsService, DatastoreService } from '../../services';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {

  config: any;
  site: string = "";
  companyDetails: any;

  constructor(
    private route: ActivatedRoute,
    private dataStore: DatastoreService,
    private commonFunctionsService: CommonFunctionsService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(async params => {
      await this.commonFunctionsService.setCompanyName(params);
      this.site = params.site;
    });
  }

}
